import React, {useState, useEffect} from 'react';
import { Container } from 'reactstrap';
import Buttons from '../buttons';
import ResultsFrameWork from './resultsFramework';
import InstitutionalIndicators from './institutional-indicators';
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import { Utilities, Enums } from '@utils';
import { AEAPopOver } from "@/components/";
export interface IFollowUpIndicatorsProps{    
    projectData: any;
    screen: string;
    activeTab: number;
    setIndicatorsActData: Function;
}

const FollowUpIndicators: React.FC<IFollowUpIndicatorsProps> = ({projectData, screen, activeTab, setIndicatorsActData}: IFollowUpIndicatorsProps) =>  {
    const [dataColumns, setDataColumns] = useState(null);
    const [dimensionData, setDimensionData] = useState(null);
    const [auxScreen, setAuxScreen] = useState(screen);
    const [objIndicatorData, setObjIndicatorData] = useState(null);
    const [resIndicatorData, setResIndicatorData] = useState(null);
    const [actIndicatorData, setActIndicatorData] = useState(null);
    const [tableAlerts, setTableAlerts] = useState(null);
    const [existError, setExistError] = useState(false);
    const [institutionalIndData, setInstitutionalIndData] = useState(null);
    const [initialValidateFrame, setInitialValidateFrame] = useState(true);
    const [initialValidateActPlan, setInitialValidateActPlan] = useState(true);
    const [initialValidateIns, setInitialValidateIns] = useState(true);
    const [finishTour, setFinishTour] = useState(false);

    const [missedIndicatorsActData, setMissedIndicatorsActData] = useState<any>([]);

    const view: IFollowupSubproject = {
        state: {
            objIndicatorData,
            resIndicatorData,
            actIndicatorData,
            projectData,
            dataColumns,
            dimensionData,
            institutionalIndData,
            setDimensionData,
            setObjIndicatorData,
            setResIndicatorData,
            setActIndicatorData,
            setTableAlerts,
            setExistError,
            setInstitutionalIndData, 
            setDataColumns,
            setInitialValidateFrame,
            setInitialValidateActPlan,
            setInitialValidateIns,
            missedIndicatorsActData,
            setMissedIndicatorsActData
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    useEffect(() => {
        presenter.initIndicators()
        presenter.initialize()
        return () => {(presenter.clear())}
    }, []);

    useEffect(() => {
        if(!!missedIndicatorsActData.length) {
            setIndicatorsActData(missedIndicatorsActData)
        }
    }, [missedIndicatorsActData]);

    useEffect(() => {
        let isSubscribed = true;
        if(activeTab === 0){
            if((existError || (institutionalIndData && objIndicatorData)) && dataColumns && presenter.institutionalIndicators && dimensionData && presenter.resultsFramework) presenter.unSetLoading()
            else presenter.keepLoading()
        }
        return () => {(isSubscribed = false)}
    }, [institutionalIndData, objIndicatorData, presenter.institutionalIndicators, dimensionData, presenter.resultsFramework, dataColumns, activeTab, existError]);

    useEffect(() => {
        let isSubscribed = true;
        if(presenter.subProjectDimensions?.length) presenter.getDimensionData(Enums.FollowupDimensions.indicators)
        return () =>{(isSubscribed = false)}
    }, [presenter.subProjectDimensions]);

    useEffect(() => {
        let isSubscribed = true;
        if(presenter.resultsFramework && presenter.indicatorsData && dimensionData && !objIndicatorData) {
            presenter.getIndicatorsData(presenter.resultsFramework, Number(projectData?.year))
        }
        return () =>{(isSubscribed = false)
        }
    }, [presenter.resultsFramework, dimensionData, presenter.indicatorsData]);

    useEffect(() => {
        let isSubscribed = true;
        if(presenter.institutionalIndicators && presenter.indicatorsData && dimensionData && !institutionalIndData){
            presenter.getInstitutionalIndData(presenter.institutionalIndicators, Number(projectData?.year))
        } 
        return () =>{ (isSubscribed = false)}
    }, [presenter.institutionalIndicators, dimensionData, presenter.indicatorsData]);

    useEffect(() => {
        let isSubscribed = true;
        const canEdit = (screen === Enums.FollowupState.edit)
        if(dimensionData && presenter.subProjectDimensions && canEdit) {
            let isAllClosed: boolean = presenter.checkCloseMonths(dimensionData)
            let currentUser = presenter.getCurrentUser()
            let otherEdit = (!!dimensionData?.EnEdicion && currentUser.currentUser.userPrincipalName !== dimensionData?.PProaModifiedBy?.Name?.replace("i:0#.f|membership|", "")) || !dimensionData?.EnEdicion
            setAuxScreen((isAllClosed || otherEdit) ? Enums.FollowupState.view : screen)
        }
        return () => {(isSubscribed = false)}
    }, [presenter.subProjectDimensions, dimensionData, screen]);

    let visible = presenter.loadingFinished()
    let dimensionTour = (!presenter.tourIndSeen && dimensionData) ? presenter.getTourDimension(Enums.FollowupDimensions.indicators, dimensionData) : null

    useEffect(() => {
        let isSubscribed = true;
        if(existError && visible && activeTab === 0) Utilities.notifyError(
            presenter.followupLabels.get("errorInDimensionState"),
            presenter.followupLabels.get("errorInDimensionStateTitle")
        )
        return () => {(isSubscribed = false)}
    }, [existError, visible, activeTab]);

    useEffect(() => {
        if(!presenter.tourIndSeen && presenter.stepTourInd === 1 && visible && !existError){
            Utilities.notifyTour(presenter.followupLabels.get("IndicatorsTourStep1"),
                presenter.followupLabels.get("tourWelcome"),
                `${presenter.followupLabels.get("tourBtnNext")} (${presenter.stepTourInd}/16)`,
                presenter.followupLabels.get("tourBtnSkip")
            )
            .then((res) => {
                if(res)presenter.changeStepTour(presenter.stepTourInd + 1, Enums.FollowupDimensions.indicators);
                else setFinishTour(true)
            })
        }
    }, [presenter.tourIndSeen, presenter.stepTourInd, visible, existError]);

    useEffect(() => {
        if(finishTour){
            presenter.toggleTour(Enums.FollowupDimensions.indicators, true)
            setFinishTour(false)
        }
    }, [finishTour]);

    return (
        <Container fluid={true}>
            { (dataColumns && dimensionData && !existError) ?
            
                <>
                    <Buttons
                        stepTour={presenter.stepTourInd}
                        initialValidate={(initialValidateFrame || initialValidateIns) && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourIndSeen}
                        currentYear={Number(projectData?.year)} 
                        save={presenter.saveData} 
                        check={presenter.checkData} 
                        dimensionData={dimensionTour ||dimensionData}
                        followupLabels={presenter.followupLabels}
                        formMasters={presenter.formMasters}
                        step={1} 
                        screen={screen}
                        toggleEditing={presenter.toggleEditing} 
                        currentUser={presenter.getCurrentUser()}
                        startTour={() => presenter.toggleTour(Enums.FollowupDimensions.indicators, false)}
                    />
                    <InstitutionalIndicators 
                        initialValidate={initialValidateIns && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourIndSeen}
                        institutionalIndData={institutionalIndData}
                        tableAlerts={presenter.tourIndSeen ? tableAlerts : null} 
                        status={dimensionData}
                        dataColumns={dataColumns} 
                        screen={!presenter.tourIndSeen ? Enums.FollowupState.edit : auxScreen} 
                        projectData={projectData}
                        saveTable={presenter.saveTable} 
                    />
                    <ResultsFrameWork 
                        initialValidate={initialValidateFrame && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourIndSeen}
                        initialValidateActPlan={initialValidateActPlan}
                        tableAlerts={presenter.tourIndSeen ? tableAlerts : null}
                        status={dimensionData}
                        dataColumns={dataColumns}
                        screen={!presenter.tourIndSeen ? Enums.FollowupState.edit : auxScreen} 
                        objIndicatorData={objIndicatorData}
                        resIndicatorData={resIndicatorData}
                        actIndicatorData={actIndicatorData}
                        projectData={projectData} 
                        saveTable={presenter.saveTable}
                        dimensionData={dimensionData}

                    />
                    {(visible && !presenter.tourIndSeen) &&
                        <AEAPopOver
                            popOverScroll={presenter.getScrollTour(presenter.stepTourInd, Enums.FollowupDimensions.indicators)}
                            stepPosition={presenter.getPositionTour(presenter.stepTourInd, Enums.FollowupDimensions.indicators)} 
                            visible={visible && !presenter.tourIndSeen} 
                            step={presenter.stepTourInd} 
                            totalStep={16}
                            changeStepTour={(step: number) => presenter.changeStepTour(step, Enums.FollowupDimensions.indicators)}
                            finishTour={() => presenter.toggleTour(Enums.FollowupDimensions.indicators, true)} 
                            labelDimension={'IndicatorsTourStep'} 
                            followupLabels={presenter.followupLabels}
                        /> 
                    } 
                </>
                : <div ></div>
            }
            { existError && 
                <div style={{width:"100%", textAlign:"center", color:"red", padding:"1rem"}}>{presenter.followupLabels.get("errorInDimensionState")}</div>
            }
        </Container>
    );       
}

export default FollowUpIndicators;